import { Box, Typography } from '@mui/material'
import { useAuthContext } from 'context/AuthContext'
import Loader from 'components/Loader'
import Header from 'components/Header'
import { Sidebar } from 'components/sidebar'
import { AppWrapper } from './Layout.styles'
import type { LayoutProps } from './Layout.types'

const Layout = ({ children, title, description }: LayoutProps): JSX.Element => {
  const { isLoading } = useAuthContext()

  return (
    <AppWrapper>
      <Header />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 4, overflow: 'auto' }}>
        {!!title && (
          <Typography component="h1" variant="h5" mb={!!description ? 0.5 : 2} fontWeight={600}>
            {title}
          </Typography>
        )}
        {!!description && (
          <Typography component="p" variant="body1" mb={2} fontWeight={400} color="grey.600">
            {description}
          </Typography>
        )}
        {isLoading ? <Loader /> : children}
      </Box>
    </AppWrapper>
  )
}

export default Layout
